import React from "react"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"

export default function ToolbarMoreButton(state: any, props: any) {

    const classes = Classes("flex-row-center-center", {
        'show-popover': state.showPopover
    })

    return (
        <ControlButtonStandard className={classes}>
            <div className="ui5-ico-16 editor-i5-more"/>
        </ControlButtonStandard>
    )
}